import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

import LoadingDialog from '../../../../components/loadingdialog/components/loadingdialog';
import CoderChip from '../../../../components/coderchip/coderchip';
import useAuditSearch from '../../../../modules/hooks/auditsearch/hook';
import { INPUT_TYPES } from '../../../../modules/hooks/auditsearch/hook';

const useStyles = makeStyles(theme => ({
  root: {
  },
  dropdownwithlabel: {
    '& div:first-child': {
      width:'150px',
      display:'inline-block'
    },
    marginBottom:'4px'
  },
  specialLabel: {
    width:'150px',
    display:'inline-block'
  },
  searchbutton: {
    '& div:first-child': {
      width:'150px',
      display:'inline-block'
    },
    marginBottom:'4px',
    marginTop:'20px'
  }
}));

const Search = ({
  service
}) => {
  const history = useHistory();
  const [state, boundActions] = useAuditSearch(service);

  const classes = useStyles();

  return (
    <div>
      <h3>Audit Search</h3>

      {/* select contract */}
      <div className={classes.dropdownwithlabel}>
        <div>Contract:</div>
        <select
          onChange={boundActions.setSelectedContract}
          value={state.contracts.selectedItem}
        >
          <option value="-1">Choose a Contract</option>
          {
            state.contracts.items.map(x => (
              <option
                key={x.value}
                value={x.value}
              >
                {x.label}
              </option>
            ))
          }
        </select>
      </div>

      {/* select facility */}
      <div className={classes.dropdownwithlabel}>
        <div>Facility:</div>
        <select
          onChange={boundActions.setSelectedFacility}
          value={state.facilities.selectedItem}
        >
          <option value="-1">Choose a Facility</option>
          {
            state.facilities.items.map(x => (
              <option
                key={x.value}
                value={x.value}
              >
                {x.label}
              </option>
            ))
          }
        </select>
      </div>

      {/* new hcc only & on hold only */}
      <div className={classes.dropdownwithlabel}>
        <div>Show Only New HCC:</div>
          <input
            name="showOnlyNewHCC"
            type="checkbox"
            value={state.inputs[INPUT_TYPES.CHECKBOX].showOnlyNewHCC}
            onChange={() => boundActions.changeNewHCCOnlyValue(
              !state.inputs[INPUT_TYPES.CHECKBOX].showOnlyNewHCC
            )}
          />
      </div>

      <div className={classes.dropdownwithlabel}>
        <div>Show Only On Hold:</div>
          <input
            name="showOnlyOnHold"
            type="checkbox"
            value={state.inputs[INPUT_TYPES.CHECKBOX].showOnlyOnHold}
            onChange={() => boundActions.changeOnlyOnHoldValue(
              !state.inputs[INPUT_TYPES.CHECKBOX].showOnlyOnHold
            )}
          />
      </div>

      {/* mrn & account number */}
      {/* mrn */}
      <div className={classes.dropdownwithlabel}>
        <div>MRN:</div>
        <input
          name="mrn"
          type="text"
          value={state.inputs[INPUT_TYPES.TEXT].mrn}
          onChange={e => {
            const value = e.target.value;
            boundActions.changeMrnValue(value);
          }}
        />
      </div>

      {/* account number */}
      <div className={classes.dropdownwithlabel}>
        <div>Account Number:</div>
        <input
          name="accountNumber"
          type="text"
          value={state.inputs[INPUT_TYPES.TEXT].accountNumber}
          onChange={e => {
            const value = e.target.value;
            boundActions.changeAccountNumberValue(value);
          }}
        />
      </div>


      {/* coders */}
      <div>
        <div className={classes.specialLabel}>Coders:</div>
        <div style={{ display: 'inline-block', marginRight:'15px' }}>
          <select
            value={state.auditCoders.selectedItem}
            onChange={e => {
              const val = e.target.value;
              boundActions.selectCoder(val);
            }}
          >
            <option value="-1">Choose a Coder</option>
            {
              state.auditCoders.items.map(x => (
                <option
                  key={x.value}
                  value={x.value}
                >
                  {x.label}
                </option>
              ))
            }
          </select>
        </div>

        <div style={{ display: 'inline-block' }}>
          <span>Selected Coder(s): </span>
          {
            state.selectedCoders.map(x => (
              <CoderChip
                key={x.value}
                isDelible={true}
                onDelete={() => boundActions.removeCoder(x)}
                coder={x}
              />
            ))
          }
        </div>
      </div>

      {/* search button */}
      <div className={classes.searchbutton}>
        <div>
          <button onClick={() => {
            const dto = {
              selectedContract: { value: state.contracts.selectedItem },
              selectedFacility: { value: state.facilities.selectedItem },
              dateOfService: null, // TODO implement in future (see doc)
              patientName: '', // TODO implement in future (see doc)
              finalizedOnStart: null, // TODO implement in future (see doc)
              finalizedOnEnd: null, // TODO implement in future (see doc)
              accountNumber: state.inputs[INPUT_TYPES.TEXT].accountNumber,
              mrn: state.inputs[INPUT_TYPES.TEXT].mrn,
              selectedCoders: state.selectedCoders,
              encountersWithNewCodeCategory:
                state.inputs[INPUT_TYPES.CHECKBOX].showOnlyNewHCC === true
                  ? 'yes'
                  : 'no',
              encountersOnAuditHold:
                state.inputs[INPUT_TYPES.CHECKBOX].showOnlyOnHold === true
                  ? 'yes'
                  : 'no'
            };

            boundActions.getEncounterCount(dto);
          }}>
            <span>Search</span>
          </button>
        </div>

        <label>Number of Encounters: {state.numberOfEncounters}</label>
      </div>

      {/* begin work button */}
      <div>
        <button
          disabled={state.numberOfEncounters < 1}
          onClick={() => {
            boundActions.beginWork(history.push);
          }}
        >
          <span>Begin Work</span>
        </button>
      </div>

      <LoadingDialog
        isOpen={state.isLoading}
        loadingMessage={state.statusMessage}
      />
    </div>
  );
};

Search.propTypes = {
  service: PropTypes.shape({
    // TODO
  }).isRequired
};

export default Search;
